import * as React from 'react';
import Select from 'react-select'


interface IState {
    loading: boolean,
    fileName:string,
    fileReady:boolean,
    data: any,
    selected : string[]
}

export default class Compare extends React.Component<any, IState> {
    private url: any;

    constructor(props: any) {
        super(props);
        this.state = {
            loading: false,
            fileName: "",
            fileReady:false,
            data: [],
            selected : []
        }
    }

    componentWillMount() {
        this.url = window.location.origin;
        if (window.location.port === "8080") {
            this.url = this.url.replace("8080", "3000");
        } else if(window.location.port === "") {
            this.url = this.url + ":1000";
        }

        this.getAnalisis();
    }

    get listBuku() {
        let data: any = [];

        this.state.data.forEach((d: any, i: any) => {
            data.push({ value: i, label: d.buku })
        });
        return data;
    }

    getLaporanKomparasi () {
        this.setState({ loading: true });
        const self = this;
        $.ajax({
            type: "POST",
            url: this.url + "/api/compareAnalisa",
            data: { data: JSON.stringify(this.state.selected) },
        }).done(function (res: any) {
            if (res.filename === undefined) {
                console.error(res);
                alert("Error !!!")
            } else {
                self.setState({ loading: false, fileName: res.filename,fileReady:true})
            }
        }).fail(function (res: any) {
            console.error(res);
            alert("Failed");
        });
    }

    download() {
        if (this.state.fileName === '') return alert('Data report not found !!! Please scan document again.');
        location.href = this.url + '/download/' + this.state.fileName
    }

    getAnalisis() {
        this.setState({ loading: true });
        const self = this;
        $.ajax({
            type: "POST",
            url: this.url + "/api/db/queryAll",
            data: { sql: "SELECT * FROM analisis ORDER BY timestamp DESC" },
            dataType: "JSON"
        }).done(function (res: any) {
            if (res.status === "error") {
                console.error(res);
                alert("Error !!!")
            } else {
                if (res.msg === null) res.msg = [];
                self.setState({ loading: false, data: res.msg })
            }
        }).fail(function (res: any) {
            console.error(res);
            alert("Failed");
        });
    }

    viewHistory(idx: any) {
        const data:any = this.state.data[idx]
        let selected = this.state.selected;
        selected.push(data.id)
        this.setState({selected})
    }

    render() {
        return <div>
            <div style={{ padding: 25 }}>
                <div className="panel">
                    <div className="panel-header">
                        <button className="btn btn-primary" onClick={() => this.getLaporanKomparasi()} style={{marginRight: 25}}> Bandingkan Buku </button>
                        <button className="btn btn-success" disabled={this.state.fileReady == false} onClick={() => this.download()}><i className="icon icon-download"></i> Download Report </button>
                    </div>

                    <div className="panel-body">
                        <div className="panel" style={{marginBottom:10}}>
                            <div className="panel-header" style={{ fontWeight: 800 }}>
                                <Select options={this.listBuku} onChange={(e: any) => this.viewHistory(e.value)} />
                            </div>
                        </div>

                        <div className="panel" style={{marginBottom:10}}>
                            <div className="panel-header" style={{ fontWeight: 800 }}>
                                <Select options={this.listBuku} onChange={(e: any) => this.viewHistory(e.value)} />
                            </div>
                        </div>

                        <div className="panel" style={{marginBottom:10}}>
                            <div className="panel-header" style={{ fontWeight: 800 }}>
                                <Select options={this.listBuku} onChange={(e: any) => this.viewHistory(e.value)} />
                            </div>
                        </div>

                        <div className="panel" style={{marginBottom:10}}>
                            <div className="panel-header" style={{ fontWeight: 800 }}>
                                <Select options={this.listBuku} onChange={(e: any) => this.viewHistory(e.value)} />
                            </div>
                        </div>

                        <div className="panel" style={{marginBottom:10}}>
                            <div className="panel-header" style={{ fontWeight: 800 }}>
                                <Select options={this.listBuku} onChange={(e: any) => this.viewHistory(e.value)} />
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/pages/Compare.tsx